import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import { useSelector, useDispatch } from "react-redux";
import PrefferedLanguage from "../../components/Settings/PrefferedLanguage";
import PropTypes from "prop-types";
import DomainListComponent from "../../components/DomainList";

const DomainList = (props, context) => {
  //   const profileReducer = useSelector((state) => state.profileReducer);
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);
  const userAuthAction = bindActionCreators(userAuthActions, dispatch);

  const userAuthReducer = useSelector((state) => state.userAuthReducer);

  //   const profileAction = bindActionCreators(profileActions, dispatch);



  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };
  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  // Close modal component on change component
  // useEffect(() => {
  //   return () => {
  //     closeRemoveModal();
  //   };
  // }, []);

  const handleSubmit = (data) => {
    let payload = {
      "companyId": userAuthReducer.selectedCompany,
      "lstDomains": data.domainList
    }
    userAuthAction.saveDomains(payload);
    closeRemoveModal();
  }

  const onDomainDelete = (selectedDomain) => {
    userAuthAction.onDomainDelete(selectedDomain);
  }

  const resetConfirmationValue = (confirmationValue,isSelectedUserLoaded) => {
    userAuthAction.resetDomainValues(confirmationValue,isSelectedUserLoaded);
  }

  return (
    <DomainListComponent
      context={context}
      closeRemoveModal={closeRemoveModal}
      openSetModal={openSetModal}
      {...props}
      selectedCompany={userAuthReducer.selectedCompany}
      selectedDomainUsers={userAuthReducer.selectedDomainUsers}
      isSelectedUserLoaded={userAuthReducer.isSelectedUserLoaded}
      confirmationValue={userAuthReducer.confirmationValue}
      resetConfirmationValue={resetConfirmationValue}
      domainList={userAuthReducer.domainList}
      handleSubmit={handleSubmit}
      onDomainDelete={onDomainDelete}
    //   lastLoginDetails={profileReducer.lastLoginDetails}
    />
  );
};

// LastLoginDetails.contextTypes = {
//   t: PropTypes.func.isRequired,
// };
export default DomainList;
